<template>
	<div class="full-container">
        <div class="header-container" v-if="!isClient">
            <div class="logo-view"><img src="/logo.png" alt="" /></div>
        </div>
        <div class="header-zw" v-if="!isClient"></div>
		<router-view></router-view>
	</div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'

export default {
	components: {},
	data() {
		return {
			isClient: CheckLibs.isClient()
		}
	},
	mounted() {
		
	},
};
</script>

<style lang="less" scoped>
.header-zw{
    width: 100%;
    height: 64px;
}
.header-container{
    background-color: #161823;
    width: 100%;
    height: 64px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    .logo-view{
        width: 800px;
        height: 36px;
        margin: 0 auto;
        text-align: left;
        img{
            height: 100%;
        }
    }
}
</style>
